import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from 'src/app/components/header/header.component';
import { FooterComponent } from 'src/app/components/footer/footer.component';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { RegUser } from '../basic-reg/RegUser';
import { Globals } from 'src/app/globals';

@Component({
  selector: 'app-platform-vs-pipeline',
  templateUrl: './platform-vs-pipeline.component.html',
  styleUrls: ['./platform-vs-pipeline.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    RouterModule,
    HeaderComponent,
    FooterComponent
  ]
})
export class PlatformVsPipelineComponent implements OnInit {

  user: RegUser = new RegUser();
  LoggedIn: boolean = false;

  constructor(public authService: AuthServiceService, public global: Globals) { }

  ngOnInit(): void {
  }

  ionViewWillEnter() {    
    this.user = this.authService.getLoggedInUser();
    this.LoggedIn = this.authService.isLoggedIn();
    if (!this.global.isEmpty(this.user)) {
      this.user.imageUrl = this.authService.getProfilePicture() as string;
    }
  }

}
